import React from 'react';
import Checkbox from '@material-ui/core/Checkbox';

export default function IndeterminateCheck(props) {
  return (
    <Checkbox
      key={props.key}
      checked={true}
      value="checkedF"
      disableRipple
      indeterminate
      style={{padding: '0.4em 0.4em'}}
    />
  );
}